import React from 'react'
import { useEffect, useState } from "react";
import {Figure,Form} from 'react-bootstrap';
import {CartState} from '../context/contextmen'
 import '../cssfiles/Addtocart.css'

function Addtocart() {
  const {state: { cart }, dispatch} = CartState();
  const [total, setTotal] = useState();

  useEffect(() => {
    setTotal(
      cart.reduce((acc, curr) => acc + Number(curr.price) * curr.qty, 0)
    );
  }, [cart]);
    
  return (
    
    
        
      <div> 
       {cart.length>0 ?
      cart.map((item, index)=>{  
        
         
        
        return <div className='container '><Figure key={index} className="item-list container mt-4">
        <h4 className='close' onClick={()=>dispatch({type : 'REMOVE_FROM_CART', payload: item})}> X</h4><Figure.Image 
          
          alt="171x180"
          src={item.Image}
        className = "img container"/>
        <Figure.Caption>
          MRP:{item.price}
        </Figure.Caption>
        <Figure.Caption>
            Quantity : {item.qty}
        </Figure.Caption>
        <p className='hehe'>Price : ${item.qty*item.price}</p>
        <div>
        <Form.Control
        
                    as="select"
                    value={item.qty}
                    onChange={(e) =>
                      dispatch({
                        type: "CHANGE_CART_QTY",
                        payload: {
                          id: item.id,
                          qty: e.target.value,
                        },
                      })
                    }
                  >
                    
                    {
                    [...Array(item.instock).keys()].map((x) => (
                      <option key={x + 1} value={x + 1}>
                          {x + 1}
                      </option>
                  ))}
                  </Form.Control>
        </div>
        
      </Figure></div>
       }): <h1 className="noitems">no items</h1>} 
         
   {cart.length>0 && <div><h4 className='itemmss container'>Total Amount: ${total}<button className='checkout'>Check out</button></h4></div>}
        
  </div>
)
}

export default Addtocart